import type { ReactNode } from "react";
import { useEffect, useRef, useState } from "react";

import { cn } from "~/lib/ui";

import { Button } from "./button";

const MAX_EXPANDABLE_CONTENT_HEIGHT = 384;

const ExpandableText = ({ children }: { children: ReactNode }) => {
  const [isContentExpanded, setIsContentExpanded] = useState<boolean>(false);
  const [readMoreButtonActive, setReadMoreButtonActive] =
    useState<boolean>(false);
  const expandableRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setReadMoreButtonActive(
      (expandableRef.current?.scrollHeight &&
        expandableRef.current?.scrollHeight > MAX_EXPANDABLE_CONTENT_HEIGHT) ||
        false,
    );
  }, [expandableRef.current?.scrollHeight]);
  return (
    <div className="flex flex-col gap-4 bg-white px-6 py-5 shadow-sm">
      <div
        ref={expandableRef}
        className={cn(!isContentExpanded && `max-h-96 overflow-y-hidden`)}
      >
        {children}
      </div>
      <div
        className={cn(
          "hidden w-full flex-row items-end justify-end",
          readMoreButtonActive && "flex",
        )}
      >
        <Button
          variant="ghost"
          className="flex w-fit !bg-transparent px-0 !text-accentalpha-11"
          onClick={() => setIsContentExpanded(!isContentExpanded)}
        >
          {" "}
          Read {isContentExpanded ? "less" : "more..."}
        </Button>
      </div>
    </div>
  );
};

export default ExpandableText;
